import { BaseEntity } from 'yt-ng-framework';

export class TipStrucnogUsavrsavanja extends BaseEntity {
    constructor(){
        super();
    }
    
    Naziv: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        return this;
    }

    Serialize(input: TipStrucnogUsavrsavanja){
        return input;
    }
}
